import React from 'react';
import { motion } from 'motion/react';
import { MessageSquare, Languages, Wand2, ScanText, Share2, Briefcase, Brain } from 'lucide-react';
import { aiFeatures } from '../data/mock';

const iconMap = {
  Brain,
  Wand2,
  Languages,
  Share2,
  MessageSquare,
  Briefcase,
  ScanText
};

const Features = () => {
  const springConfig = {
    type: "spring",
    damping: 80,
    stiffness: 400,
    mass: 1
  };

  return (
    <section className="py-24 bg-white">
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={springConfig}
          className="text-center mb-16"
        >
          <h2 
            className="heading-large mb-4"
            style={{
              fontSize: 'clamp(32px, 4vw, 48px)',
              fontWeight: 600,
              color: '#0A0A0A',
              letterSpacing: '-0.01em'
            }}
          >
            Powerful AI Features
          </h2>
          <p 
            className="body-large max-w-2xl mx-auto"
            style={{
              fontSize: '18px',
              color: '#3C3B3D',
              lineHeight: 1.6
            }}
          >
            Everything you need to type smarter, write better, and communicate like a pro
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {aiFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon] || MessageSquare;
            return (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ ...springConfig, delay: index * 0.1 }}
                whileHover={{ y: -8, transition: { duration: 0.2 } }}
                className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl transition-shadow relative"
              >
                {/* NEW Badge */}
                {feature.isNew && (
                  <div className="absolute top-4 right-4">
                    <span className="px-2 py-1 bg-gradient-to-r from-orange-400 to-pink-400 text-white text-xs font-semibold rounded-full">
                      NEW
                    </span>
                  </div>
                )}
                
                {/* Icon */}
                <div 
                  className="w-14 h-14 rounded-full flex items-center justify-center mb-6"
                  style={{
                    background: 'linear-gradient(135deg, rgba(255, 140, 66, 0.1) 0%, rgba(255, 107, 157, 0.1) 100%)'
                  }}
                >
                  <Icon 
                    className="w-7 h-7"
                    style={{ color: '#FF6B9D' }}
                  />
                </div>

                {/* Content */}
                <h3 
                  className="heading-medium mb-3"
                  style={{
                    fontSize: '20px',
                    fontWeight: 600,
                    color: '#0A0A0A'
                  }}
                >
                  {feature.title}
                </h3>
                <p 
                  className="body-standard"
                  style={{
                    fontSize: '15px',
                    color: '#757478',
                    lineHeight: 1.6
                  }}
                >
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ ...springConfig, delay: 0.6 }}
          className="text-center mt-16"
        >
          <button
            className="btn-primary inline-flex items-center gap-2"
            style={{
              background: 'linear-gradient(135deg, #FF8C42 0%, #FF6B9D 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '26px',
              padding: '18px 32px',
              fontSize: '16px',
              fontWeight: 500,
              cursor: 'pointer'
            }}
          >
            Try All Features Free
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Features;
